<template>
  <div v-if="canRead">
    <v-toolbar flat>
      <v-btn v-if="isOnMobile" icon @click="drawer=!drawer">
        <v-icon>mdi-menu-{{ drawer ? 'close' : 'open' }}</v-icon>
      </v-btn>
      <v-tabs v-model="activeTab" :show-arrows="false" :grow="isOnMobile">
        <v-tab>{{ $t('vmail.cfg.settings.tab') }}</v-tab>
        <v-tab>{{ $t('vmail.cfg.greeting.tab') }}</v-tab>
      </v-tabs>
    </v-toolbar>
    <v-card flat :style="`height: calc(100vh - 25px - 55px);overflow-y: auto;`" class="pa-4">
      <div>
        <div v-show="activeTab === 0">
          <settings />
        </div>
        <div v-show="activeTab === 1" class="mt-6">
          <greetings />
        </div>
      </div>
    </v-card>
  </div>
  <div v-else>
    <v-row class="mt-4">
      <v-col cols="12" class="text-center">
        <v-icon color="red">mdi-alert-box-outline</v-icon>
        {{ hasMultipleActiveWatchers ? $t('vmail.notify.hasMultipleWatchers') : $t('vmail.notify.noReadPerms') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Settings from './general'
import Greetings from './greetings'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'voicemail-settings-index',
  data () {
    return {
      activeTab: 0
    }
  },
  components: { Settings, Greetings },
  computed: {
    ...mapGetters({
      vmboxesRead: 'permissions/vmboxesRead',
      vmboxReadFor: 'permissions/vmboxReadFor',
      activeWatchers: 'voicemails/activeWatchers',
      currentUserID: 'settings/userID',
      vmWatcherUserID: 'voicemails/watcherUserID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      drawerState: 'voicemails/drawerState'
    }),
    canRead: function () {
      if (this.activeWatchers.length > 1) {
        return false
      }
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.vmboxesRead
      }
      return this.vmboxReadFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    drawer: {
      get () {
        return this.drawerState
      },
      set (drawerState) {
        this.setDrawerState(drawerState)
      }
    },
    isOnMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    btnToggleMargin () {
      return this.isOnMobile ? '' : 'mr-2'
    }
  },
  methods: {
    ...mapActions({
      setDrawerState: 'voicemails/setDrawerState'
    })
  }
}
</script>

<style>
  .custom-btn-toggle {
    border-radius: 20px !important;
  }
  .v-slide-group__prev {
    display: none !important;
  }
</style>
